import { Subscription } from "@firmament-packages/paid_memberships"

declare module "@firmament-packages/paid_memberships" {
    interface Subscription {
        requiresSetup(): boolean
        endAtShortDisplay(): string
    }
}

Subscription.prototype.requiresSetup = function() {
    return !this.processorSubscriptionId
}

Subscription.prototype.endAtShortDisplay = function() {
    const endAt = this.endAt
    if (!endAt) {
        return "N/A"
    }

    const dateComponents = [
        endAt.toLocaleDateString("en-US", { month: "long" }),
        endAt.toLocaleDateString("en-US", { day: "numeric" }) + ",",
        endAt.toLocaleDateString("en-US", { year: "numeric" })
    ]
    return dateComponents.join(" ")
}
